import { Loader } from "@circle-react-uikit/Loader";
import { planTiers } from "@circle-react/helpers/planHelpers";

import { t } from "@/i18n-js/instance";
import {
  getPlanAddonPrice,
  getPlanAddonValue,
} from "@/react/helpers/planAddonHelpers";
import { planFeatures } from "@/react/helpers/plansHelpers";

import { FeatureRow } from "../FeatureRow";
import { usePlans } from "../PlansContext";
import { SectionWrapper } from "./SectionWrapper";

export const AddOns = () => {
  const { plans, isPlansLoading } = usePlans();

  if (isPlansLoading) {
    return <Loader center />;
  }

  const i18nRoot = "settings.billing.add_ons.manage";
  const addonsIncluded = "settings.billing.add_ons.included";

  return (
    <SectionWrapper sectionName={t("settings.billing.add_ons.title")}>
      <FeatureRow
        title={t("settings.billing.add_ons.manage.admins")}
        professional={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_admin_count,
          ),
        })}
        business={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_admin_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_admin_count,
          ),
        })}
        plus={t(`${i18nRoot}.unlimited`)}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.moderators")}
        professional={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.professional,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_moderator_count,
          ),
        })}
        business={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.business,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_moderator_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.enterprise,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_moderator_count,
          ),
        })}
        plus={t(`${i18nRoot}.unlimited`)}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.spaces")}
        professional={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.professional,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_space_count,
          ),
        })}
        business={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.business,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_space_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.enterprise,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_space_count,
          ),
        })}
        plus={t("pricing_plans.feature.talk_to_sales")}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.email_white_labeling")}
        professional={t(
          `settings.billing.add_ons.manage.email_white_labeling_description`,
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.email_whitelist,
            ),
          },
        )}
        business={t(addonsIncluded)}
        enterprise={t(addonsIncluded)}
        plus={t(addonsIncluded)}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.profile_fields")}
        professional={t(
          `settings.billing.add_ons.manage.profile_fields_description`,
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.profile_fields_enabled,
            ),
          },
        )}
        business={t(addonsIncluded)}
        enterprise={t(addonsIncluded)}
        plus={t(addonsIncluded)}
      />
      <FeatureRow
        title={t("settings.billing.add_ons.live_stream.live_attendees")}
        professional={t(
          "settings.billing.add_ons.live_stream.live_attendees_professional",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.live_stream_max_spectator_capacity,
            ),
          },
        )}
        enterprise={t(
          "settings.billing.add_ons.live_stream.live_attendees_enterprise",
        )}
        business={t(
          "settings.billing.add_ons.live_stream.live_attendees_business",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.business,
              planFeatures.live_stream_max_spectator_capacity,
            ),
          },
        )}
        plus={t(`settings.billing.add_ons.live_stream.live_attendees_plus`)}
      />
      <FeatureRow
        title={t("settings.billing.add_ons.live_stream.hours")}
        professional={t(
          "settings.billing.add_ons.live_stream.hours_professional",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.live_stream_monthly_stream_hours,
            ),
          },
        )}
        enterprise={t("settings.billing.add_ons.live_stream.hours_enterprise", {
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.live_stream_monthly_stream_hours,
          ),
        })}
        business={t("settings.billing.add_ons.live_stream.hours_business", {
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.live_stream_monthly_stream_hours,
          ),
        })}
        plus={t(`settings.billing.add_ons.live_stream.hours_plus`)}
      />
    </SectionWrapper>
  );
};
